import styled from "styled-components";

import { colors } from "shared/ui/tokens";

export const Errors = styled.ul`
    margin: 0;
    padding-left: 18px;
    display: flex;
    flex-direction: column;
    gap: 6px;
    font-size: 13px;
    color: ${colors.danger};
`;
